import React from 'react';
import { Carousel } from 'nuka-carousel';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';

import { dispatchResizeEvent } from 'helpers/window';

import AbstractCmsElement from './AbstractCmsElementNew';


export default class CmsElementCarousel extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  afterSlide = () => {
    dispatchResizeEvent();
  };

  render() {
    const { shown } = this.state;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={'ms-carousel ' + shownClass + this.getResponsiveClasses() + this.getCssClasses()}
      >
        {this.getElementStyle()}

        {this.props.children ? (
          <Carousel
            afterSlide={this.afterSlide}
            showArrows
            showDots
            // wrapMode="wrap"
          >
            {this.props.children.map((child, i) => {
              const params = child.props.params.slice();
              params.push({ name: 'fullHeight', value: this.getParamValue('fullHeight', 'no') });
              return (
                <div key={i} style={{ width: '100%', flexShrink: 0 }}>
                  {React.cloneElement(child, { params })}
                </div>
              );
            })}
          </Carousel>
        ) : null}

        {this.getAppendHtml()}
      </div>
    );

    return (
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>

    );
  }
}
CmsElementCarousel.defaultProps = {
  index: '0',
};
